export const goToStepUpAuth = (data: any) => {
  const { redirectUrl } = data.error ?? {}

  if (redirectUrl) {
    // We're receiving the redirectUrl with the params to return back already
    window.location.assign(redirectUrl)
  }
}
